'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

require('./accordion.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withPadding = require('../with-padding/with-padding');

var _withPadding2 = _interopRequireDefault(_withPadding);

var _propTypes3 = require('../../utils/prop-types');

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPANDED = 'expanded';
var COLLAPSED = 'collapsed';
var titleProps = {
  weight: 'bold'
};

var Accordion = function (_React$Component) {
  _inherits(Accordion, _React$Component);

  function Accordion(props) {
    _classCallCheck(this, Accordion);

    var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));

    _this.state = { isExpanded: _this.props.initialState === EXPANDED };
    return _this;
  }

  _createClass(Accordion, [{
    key: 'renderTitle',
    value: function renderTitle() {
      var title = this.props.title;


      if (typeof title === 'function') {
        return title(titleProps);
      }

      return _react2.default.createElement(
        _text2.default,
        titleProps,
        title
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isExpanded = this.state.isExpanded;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          disableExpand = _props.disableExpand,
          size = _props.size,
          renderActions = _props.renderActions,
          props = _objectWithoutProperties(_props, ['className', 'children', 'disableExpand', 'size', 'renderActions']);

      var initialState = props.initialState,
          padding = props.padding,
          title = props.title,
          propsToPropagate = _objectWithoutProperties(props, ['initialState', 'padding', 'title']);

      var classes = (0, _classnames2.default)('accordion', size && 'accordion-size--' + size, className);

      return _react2.default.createElement(
        'div',
        _extends({ className: classes }, propsToPropagate),
        !disableExpand && _react2.default.createElement(
          'div',
          { className: 'accordion__actions' },
          _react2.default.createElement(_icon2.default, {
            name: isExpanded ? 'arrow-down' : 'arrow-right', size: '12',
            className: 'accordion__toggle-icon',
            onClick: function onClick() {
              return _this2.setState({ isExpanded: !isExpanded });
            }
          })
        ),
        renderActions && _react2.default.createElement(
          'div',
          { className: 'accordion__actions' },
          renderActions()
        ),
        _react2.default.createElement(
          'div',
          { className: 'accordion__content-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'accordion__header' },
            this.renderTitle()
          ),
          _react2.default.createElement(
            'div',
            { className: 'accordion__content' },
            isExpanded && children
          )
        )
      );
    }
  }]);

  return Accordion;
}(_react2.default.Component);

Accordion.propTypes = _extends({
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  disableExpand: _propTypes2.default.bool,
  initialState: _propTypes2.default.oneOf([EXPANDED, COLLAPSED]),
  size: _propTypes4.default.size,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  renderActions: _propTypes2.default.func
}, _withPadding.withPaddingPropTypes);

Accordion.defaultProps = {
  disableExpand: false,
  initialState: COLLAPSED,
  padding: ['x-small', 'medium'],
  size: 'medium'
};

exports.default = (0, _withPadding2.default)(Accordion, { padding: ['x-small', 'medium'] });